/*
 * 차트 개인화(p13n) 재조회 여부를 판단하는 시그니처.
 *
 * ChartComposed / PivotChartComposed 는 시리즈 설정이 바뀔 때 p13n 을 다시 읽는다. 그런데
 * 시리즈에는 **번역문**(series.text / groupName)이 같이 들어 있어서, 언어만 바꿔도 설정 객체의
 * 값이 달라지고 그때마다 GET /api/p13n/{pageCd} 가 다시 나갔다(그리드와 같은 pageCd 라 화면이
 * 통째로 깜빡였다).
 *
 * p13n 응답은 "무엇을 그리느냐"에만 달려 있다 — 조회 키인 chartId 도, 시리즈 매칭도 전부
 * series.field 기반이다(ChartComposed 의 dataToChartData, PivotChartComposed 의
 * pivotDataToChartData 참고). 그래서 여기서는 **field 목록만** 시그니처로 삼는다.
 *
 * type / orientation 은 일부러 제외한다.
 *   - type 은 p13n 이 돌려주는 값이지 조회 조건이 아니다.
 *   - 토글 버튼이 series.type 을 in-place 로 바꾸므로, 시그니처에 넣으면 토글할 때마다 재조회가
 *     일어나 방금 토글한 type 이 p13n 값으로 되돌아간다.
 */
const SEP = "|#|";

const chartP13nSignature = (viewName, series, extra) => {
  const fields = (series ?? []).map(row => row?.field ?? "");

  return [viewName ?? "", ...(extra ?? []), ...fields].join(SEP);
};

export default chartP13nSignature;
